import { Navigate, useParams } from 'react-router-dom';

import { useGetBodega } from '@/shared/actions/erp';
import { LoaderComponent } from '@/shared/components/ui';
import { SaveBodegas } from '../../shared/saveBodegasPage';
import { useCheckPermissions } from '@/shared';
import { PermissionsEnum } from '@/auth/interfaces';

export interface UpdateBodegaPageInterface {}

const UpdateBodegasPage: React.FC<UpdateBodegaPageInterface> = () => {
  useCheckPermissions(PermissionsEnum.api_change_bodega);

  const { id } = useParams();
  const { data, isLoading } = useGetBodega(id!);

  if (isLoading) return <LoaderComponent />;
  if (!data?.data?.id_bodega) return <Navigate to="/inventario/bodegas" />;

  return <SaveBodegas titlePage="Editar bodegas" editBodegas={data.data} />;
};

export default UpdateBodegasPage;
